const DEFAULT_ISO27001_DATA = {
  hero: {
    badge: 'Uluslararası Bilgi Güvenliği Standardı',
    badge_en: 'International Information Security Standard',
    title: 'ISO 27001 ile Bilgi Güvenliğinizi Güvence Altına Alın',
    title_en: 'Secure Your Information Security with ISO 27001',
    description:
      'ISO/IEC 27001, kuruluşların bilgi varlıklarını korumak için yapılandırılmış bir çerçeve sunan uluslararası bilgi güvenliği yönetim standardıdır. Risk değerlendirmesi, risk yönetimi ve sürekli iyileştirmeyi kapsayan bu standart; dünya genelinde 70.000\'den fazla sertifika ile en yaygın benimsenen güvenlik standartlarından biridir.',
    description_en:
      'ISO/IEC 27001 is an international information security management standard that provides a structured framework for organizations to protect their information assets. Covering risk assessment, risk management, and continuous improvement, it is one of the most widely adopted security standards worldwide with over 70,000 certificates.',
    primaryButtonText: 'Ücretsiz Demo İste',
    primaryButtonText_en: 'Request Free Demo',
    secondaryButtonText: 'Uzmanla Görüş',
    secondaryButtonText_en: 'Talk to an Expert',
    cardTitle: 'ISO 27001:2022',
    cardTitle_en: 'ISO 27001:2022',
    cardSubtitle: 'Bilgi Güvenliği Yönetim Sistemi',
    cardSubtitle_en: 'Information Security Management System',
    cardTags: 'Gizlilik, Bütünlük, Erişilebilirlik',
    cardTags_en: 'Confidentiality, Integrity, Availability',
    statItems: [
      { value: '70K+', value_en: '70K+', title: 'Küresel Sertifika', title_en: 'Global Certificates' },
      { value: '150+', value_en: '150+', title: 'Ülke', title_en: 'Countries' },
      { value: '%30', value_en: '30%', title: 'İhlal Azalması', title_en: 'Breach Reduction' },
      { value: '3 Ay', value_en: '3 Mo', title: 'Ortalama Süre', title_en: 'Average Duration' },
    ],
  },

  features: {
    Title: 'Neden ISO 27001?',
    Title_en: 'Why ISO 27001?',
    Description: 'Sertifikanın İşletmenize Kattığı Değer — Uluslararası geçerlilikte bilgi güvenliği standardına kavuşun ve rekabet avantajı elde edin.',
    Description_en: 'The Value the Certificate Adds to Your Business — Gain an internationally recognized information security standard and achieve a competitive advantage.',
    cards: [
      {
        icon: 'savings',
        title: 'Maliyet Verimliliği',
        title_en: 'Cost Efficiency',
        description: 'Güvenlik ihlallerini önleyerek zaman ve kaynak tasarrufu sağlayın. Proaktif risk yönetimi, olası olayların maliyetini önemli ölçüde azaltır.',
        description_en: 'Save time and resources by preventing security breaches. Proactive risk management significantly reduces the cost of potential incidents.',
      },
      {
        icon: 'trending_up',
        title: 'Satış Döngüsünü Hızlandırın',
        title_en: 'Accelerate Sales Cycles',
        description: 'Kapsamlı güvenlik dokümanı taleplerini azaltın. Uluslararası standartlara uyumu göstererek müzakere sürelerini kısaltın.',
        description_en: 'Reduce extensive security documentation requests. Shorten negotiation times by demonstrating compliance with international standards.',
      },
      {
        icon: 'handshake',
        title: 'Müşteri Güvenini Artırın',
        title_en: 'Build Customer Trust',
        description: 'Bilgi güvenliğine olan bağlılığınızı kanıtlayarak müşteri güvenini pekiştirin.',
        description_en: 'Reinforce customer trust by demonstrating your commitment to information security.',
      },
      {
        icon: 'emoji_events',
        title: 'Rekabet Avantajı',
        title_en: 'Competitive Advantage',
        description: 'ISO 27001 sertifikası, sizi bilgi güvenliğinde lider konumuna taşır.',
        description_en: 'ISO 27001 certification positions you as a leader in information security.',
      },
      {
        icon: 'gavel',
        title: 'Yasal Uyum Kolaylığı',
        title_en: 'Regulatory Compliance',
        description: 'GDPR, NIS 2 ve sektörel mevzuat gereksinimlerini sistematik biçimde karşılayın.',
        description_en: 'Systematically meet GDPR, NIS 2, and sector-specific regulatory requirements.',
      },
      {
        icon: 'security',
        title: 'Veri İhlali Koruması',
        title_en: 'Data Breach Protection',
        description: 'Ortalama veri ihlali maliyeti 4,45 milyon dolar. ISO 27001 kontrolleri, ihlal öncesinde koruyucu kalkan oluşturur.',
        description_en: 'The average data breach cost is $4.45 million. ISO 27001 controls establish a protective shield before breaches occur.',
      },
    ],
  },

  riskSteps: {
    title: 'ISO 27001 Risk Yönetimini Nasıl Yapılandırır?',
    title_en: 'How Does ISO 27001 Structure Risk Management?',
    subtitle: 'ISO 27001:2022, risk değerlendirmesini BGYS\'ye entegre ederek potansiyel tehditlerin sistematik biçimde tanımlanmasını, analiz edilmesini ve etkili biçimde azaltılmasını sağlar.',
    subtitle_en: 'ISO 27001:2022 integrates risk assessment into the ISMS, enabling systematic identification, analysis, and effective mitigation of potential threats.',
    steps: [
      {
        number: '01',
        title: 'Risk Tespiti ve Değerlendirmesi',
        title_en: 'Risk Identification & Assessment',
        description: 'Hassas verilere yönelik potansiyel tehditleri belirleyin; bu risklerin olasılık ve etkisini kapsamlı biçimde analiz edin.',
        description_en: 'Identify potential threats to sensitive data and comprehensively analyze the likelihood and impact of these risks.',
      },
      {
        number: '02',
        title: 'Risk Tedavisi',
        title_en: 'Risk Treatment',
        description: 'Azaltma, transfer, kaçınma veya kabul gibi uygun tedavi seçeneklerini belirleyin.',
        description_en: 'Determine appropriate treatment options such as mitigation, transfer, avoidance, or acceptance.',
      },
      {
        number: '03',
        title: 'Sürekli İzleme',
        title_en: 'Continuous Monitoring',
        description: 'Risk ortamının düzenli olarak gözden geçirilmesi ve gerektiğinde güncellenmesi, güvenliğin etkinliğini korumak için kritik öneme sahiptir.',
        description_en: 'Regular review and updating of the risk environment is critical to maintaining the effectiveness of security.',
      },
    ],
    panelTitle: 'Temel Teknikler ve Stratejiler',
    panelTitle_en: 'Key Techniques & Strategies',
    panelItems: [
      { icon: 'analytics', text: 'Risk Analizi', text_en: 'Risk Analysis' },
      { icon: 'security', text: 'Risk Tedavisi', text_en: 'Risk Treatment' },
      { icon: 'loop', text: 'Sürekli İyileştirme', text_en: 'Continuous Improvement' },
    ],
  },

  annexSection: {
    title: 'ISO 27001:2022 Kontrol Kategorileri',
    title_en: 'ISO 27001:2022 Control Categories',
    subtitle: 'ISO 27001:2022, toplam 93 kontrolü dört ana gruba yeniden yapılandırmıştır.',
    subtitle_en: 'ISO 27001:2022 has restructured a total of 93 controls into four main groups.',
    groups: [
      {
        icon: 'corporate_fare',
        group: 'Organizasyonel Kontroller',
        group_en: 'Organizational Controls',
        count: 37,
        color: 'blue',
        examples: [
          { text: 'Bilgi Güvenliği Politikaları', text_en: 'Information Security Policies' },
          { text: 'Erişim Kontrolü', text_en: 'Access Control' },
          { text: 'Tehdit İstihbaratı', text_en: 'Threat Intelligence' },
          { text: 'Tedarikçi İlişkileri', text_en: 'Supplier Relationships' },
        ],
      },
      {
        icon: 'people',
        group: 'İnsan Kaynağı Kontrolleri',
        group_en: 'People Controls',
        count: 8,
        color: 'purple',
        examples: [
          { text: 'Güvenlik Sorumlulukları', text_en: 'Security Responsibilities' },
          { text: 'Personel Eleme', text_en: 'Personnel Screening' },
          { text: 'Farkındalık Eğitimi', text_en: 'Awareness Training' },
          { text: 'Disiplin Süreci', text_en: 'Disciplinary Process' },
        ],
      },
      {
        icon: 'lock',
        group: 'Fiziksel Kontroller',
        group_en: 'Physical Controls',
        count: 14,
        color: 'orange',
        examples: [
          { text: 'Fiziksel Güvenlik İzleme', text_en: 'Physical Security Monitoring' },
          { text: 'Ekipman Koruması', text_en: 'Equipment Protection' },
          { text: 'Güvenli Alanlar', text_en: 'Secure Areas' },
          { text: 'Temiz Masa Politikası', text_en: 'Clean Desk Policy' },
        ],
      },
      {
        icon: 'memory',
        group: 'Teknolojik Kontroller',
        group_en: 'Technological Controls',
        count: 34,
        color: 'green',
        examples: [
          { text: 'Web Filtreleme', text_en: 'Web Filtering' },
          { text: 'Güvenli Kodlama', text_en: 'Secure Coding' },
          { text: 'Veri Sızıntısı Önleme', text_en: 'Data Loss Prevention' },
          { text: 'Kötü Amaçlı Yazılım Koruması', text_en: 'Malware Protection' },
        ],
      },
    ],
    newControlsTitle: 'ISO 27001:2022\'nin 11 Yeni Kontrolü',
    newControlsTitle_en: '11 New Controls in ISO 27001:2022',
    newControls: [
      { icon: 'cloud', text: 'Bulut hizmetleri güvenliği', text_en: 'Cloud services security' },
      { icon: 'radar', text: 'Tehdit istihbaratı', text_en: 'Threat intelligence' },
      { icon: 'devices', text: 'BT sistemleri iş sürekliliği', text_en: 'IT systems business continuity' },
      { icon: 'code', text: 'Güvenli kodlama standartları', text_en: 'Secure coding standards' },
      { icon: 'data_loss_prevention_on', text: 'Veri sızıntısı önleme', text_en: 'Data loss prevention' },
    ],
  },

  stepsSection: {
    title: 'ISO 27001 Sertifikasyonunu Nasıl Elde Edersiniz?',
    title_en: 'How to Achieve ISO 27001 Certification?',
    subtitle: 'Başarılı bir sertifikasyon için metodolojik bir yaklaşım gereklidir.',
    subtitle_en: 'A methodological approach is required for successful certification.',
    steps: [
      { number: '01', title: 'Boşluk Analizi', title_en: 'Gap Analysis', description: 'Mevcut güvenlik uygulamalarınızı ISO 27001 gereksinimleriyle kıyaslayarak iyileştirme alanlarını belirleyin.', description_en: 'Compare your current security practices with ISO 27001 requirements to identify areas for improvement.' },
      { number: '02', title: 'BGYS Kurulumu', title_en: 'ISMS Setup', description: 'Organizasyonunuzun hedeflerine uygun bir Bilgi Güvenliği Yönetim Sistemi kurun.', description_en: 'Establish an Information Security Management System aligned with your organization\'s objectives.' },
      { number: '03', title: 'Risk Yönetimi', title_en: 'Risk Management', description: 'İnsan, altyapı, fiziksel güvenlik ve üçüncü taraflardan kaynaklanan bilgi güvenliği risklerini belirleyin.', description_en: 'Identify information security risks from people, infrastructure, physical security, and third parties.' },
      { number: '04', title: 'Bilgi Varlıklarını Koruyun', title_en: 'Protect Information Assets', description: 'Donanım, veri ve personel dahil tüm bilgi varlıklarını belgeleyip kategorilere ayırın.', description_en: 'Document and categorize all information assets including hardware, data, and personnel.' },
      { number: '05', title: 'İç Denetimler', title_en: 'Internal Audits', description: 'BGYS\'nizin etkinliğini değerlendirmek için düzenli iç denetimler gerçekleştirin.', description_en: 'Conduct regular internal audits to assess the effectiveness of your ISMS.' },
      { number: '06', title: 'Belgelendirme Kuruluşu Denetimi', title_en: 'Certification Body Audit', description: 'Akredite bir belgelendirme kuruluşu seçin ve denetim sürecini planlayın.', description_en: 'Select an accredited certification body and plan the audit process.' },
      { number: '07', title: 'Sürekli İyileştirme', title_en: 'Continuous Improvement', description: 'Yıllık gözetim denetimleri ve 3 yıllık yeniden sertifikasyonla uyumu sürdürün.', description_en: 'Maintain compliance with annual surveillance audits and 3-year recertification.' },
    ],
  },

  pdcaSection: {
    title: 'PDCA Döngüsüyle BGYS\'nizi Kurun',
    title_en: 'Build Your ISMS with the PDCA Cycle',
    subtitle: 'Bir BGYS oluşturmanın en basit yolu, Plan-Do-Check-Act döngüsüdür.',
    subtitle_en: 'The simplest way to build an ISMS is the Plan-Do-Check-Act cycle.',
    steps: [
      { letter: 'P', label: 'Plan', label_en: 'Plan', title: 'BGYS\'yi Kurun', title_en: 'Establish the ISMS', description: 'Tüm belgeleri hazırlayın, kapsamı belirleyin ve politikaları oluşturun.', description_en: 'Prepare all documents, define scope, and establish policies.', color: 'blue' },
      { letter: 'D', label: 'Do', label_en: 'Do', title: 'Uygulayın', title_en: 'Implement', description: 'Plan aşamasında belirlenen süreç ve prosedürleri hayata geçirin.', description_en: 'Implement the processes and procedures defined in the planning phase.', color: 'green' },
      { letter: 'C', label: 'Check', label_en: 'Check', title: 'Kontrol Edin', title_en: 'Monitor', description: 'BGYS\'nizin ISO 27001 standardıyla uyumunu denetimler aracılığıyla doğrulayın.', description_en: 'Verify your ISMS compliance with ISO 27001 standard through audits.', color: 'orange' },
      { letter: 'A', label: 'Act', label_en: 'Act', title: 'İyileştirin', title_en: 'Improve', description: 'BGYS\'yi geliştirin ve bilgi güvenliği açıklarını kapatın.', description_en: 'Improve the ISMS and close information security gaps.', color: 'purple' },
    ],
  },

  auditSection: {
    title: 'Denetim Türleri: Ne Beklemelisiniz?',
    title_en: 'Audit Types: What to Expect?',
    subtitle: 'ISO 27001 sertifikasyonu, birbirini izleyen denetim aşamalarından oluşur.',
    subtitle_en: 'ISO 27001 certification consists of sequential audit phases.',
    cards: [
      { icon: 'fact_check', badge: 'Aşama 1 Denetimi', badge_en: 'Stage 1 Audit', badgeColor: 'blue', title: 'Belge İnceleme', title_en: 'Document Review', description: 'Dış denetçi, kuruluşunuzun işleyen bir BGYS için gerekli tüm belgelere sahip olup olmadığını inceler.', description_en: 'The external auditor reviews whether your organization has all the documents required for a functioning ISMS.' },
      { icon: 'domain_verification', badge: 'Aşama 2 Denetimi', badge_en: 'Stage 2 Audit', badgeColor: 'green', title: 'Uygulama Denetimi', title_en: 'Implementation Audit', description: 'Kuruluşun kendi politikalarına uygunluğu doğrulanır.', description_en: 'The organization\'s compliance with its own policies is verified.' },
      { icon: 'event_repeat', badge: 'Yıllık', badge_en: 'Annual', badgeColor: 'orange', title: 'Gözetim Denetimi', title_en: 'Surveillance Audit', description: 'Sertifikasyon ile yeniden sertifikasyon arasında yıllık periyodik denetimdir.', description_en: 'Annual periodic audit between certification and recertification.' },
      { icon: 'workspace_premium', badge: '3 Yılda Bir', badge_en: 'Every 3 Years', badgeColor: 'purple', title: 'Yeniden Sertifikasyon', title_en: 'Recertification', description: 'Standardın tüm maddelerini kapsayan ve her 3 yılda bir zorunlu tutulan yenileme denetimidir.', description_en: 'A renewal audit covering all clauses of the standard, mandatory every 3 years.' },
    ],
    failureTitle: 'Dış Denetimde Başarısız Olursanız Ne Yapmalısınız?',
    failureTitle_en: 'What to Do If You Fail the External Audit?',
    failureSubtitle: 'Majör uygunsuzluklar denetim başarısızlığına yol açabilir. Bu bir son değil, iyileştirme fırsatıdır.',
    failureSubtitle_en: 'Major nonconformities can lead to audit failure. This is not the end, but an opportunity for improvement.',
    failureSteps: [
      { icon: 'summarize', text: 'Denetim raporunu kapsamlı biçimde değerlendirin', text_en: 'Comprehensively evaluate the audit report' },
      { icon: 'forum', text: 'Dış denetçiyle iyileştirme alanlarını müzakere edin', text_en: 'Discuss improvement areas with the external auditor' },
      { icon: 'task', text: 'Sorumlu kişi ve tarihleri içeren öncelikli eylem planı oluşturun', text_en: 'Create a prioritized action plan with responsible persons and dates' },
      { icon: 'refresh', text: 'BGYS iyileştirme sürecini yeterli kaynak ayırarak yeniden başlatın', text_en: 'Restart the ISMS improvement process with adequate resources' },
      { icon: 'calendar_month', text: 'Yeni denetim tarihini belirleyin ve süreci takip edin', text_en: 'Set a new audit date and follow up on the process' },
    ],
  },

  sectorsSection: {
    title: 'ISO 27001 Kim İçin Gereklidir?',
    title_en: 'Who Needs ISO 27001?',
    subtitle: 'ISO 27001 sertifikasyonu, bilgi ve veriyle çalışan her ölçekteki kuruluş için geçerlidir.',
    subtitle_en: 'ISO 27001 certification applies to organizations of all sizes that work with information and data.',
    sectors: [
      { icon: 'account_balance', name: 'Finans ve Bankacılık', name_en: 'Finance & Banking' },
      { icon: 'local_hospital', name: 'Sağlık ve MedTech', name_en: 'Healthcare & MedTech' },
      { icon: 'school', name: 'Eğitim ve Araştırma', name_en: 'Education & Research' },
      { icon: 'gavel', name: 'Kamu ve Savunma', name_en: 'Public Sector & Defense' },
      { icon: 'wifi', name: 'Telekomünikasyon', name_en: 'Telecommunications' },
      { icon: 'cloud', name: 'Teknoloji ve SaaS', name_en: 'Technology & SaaS' },
      { icon: 'local_shipping', name: 'Lojistik ve Tedarik Zinciri', name_en: 'Logistics & Supply Chain' },
      { icon: 'storefront', name: 'Perakende ve E-ticaret', name_en: 'Retail & E-commerce' },
    ],
    footerNote: 'Günümüzde tüm büyüklükteki şirketler bilgi güvenliğini önceliklendirmek zorundadır.',
    footer_note_en: 'Today, companies of all sizes must prioritize information security.',
  },

  costSection: {
    title: 'ISO 27001 Sertifikasının Maliyeti',
    title_en: 'Cost of ISO 27001 Certification',
    subtitle: 'Sertifikasyon maliyeti; BGYS olgunluk seviyesi, kapsam genişliği ve çalışan sayısına göre farklılık gösterir.',
    subtitle_en: 'Certification cost varies depending on ISMS maturity level, scope breadth, and number of employees.',
    items: [
      {
        icon: 'build',
        phase: 'Uygulama',
        phase_en: 'Implementation',
        color: 'blue',
        items: [
          { text: 'Kapsam tanımı, risk değerlendirmesi ve boşluk analizi', text_en: 'Scope definition, risk assessment, and gap analysis' },
          { text: 'BGYS artefaktları geliştirme ve kapanış planı', text_en: 'ISMS artifact development and closure plan' },
          { text: 'Uyumluluk yazılımı ve araç maliyetleri', text_en: 'Compliance software and tool costs' },
        ],
      },
      {
        icon: 'manage_search',
        phase: 'İç Denetim',
        phase_en: 'Internal Audit',
        color: 'orange',
        items: [
          { text: 'Uyumluluk danışman saatleri (24–160 saat)', text_en: 'Compliance consultant hours (24–160 hours)' },
          { text: 'İç denetçi eğitimi ve yetkilendirmesi', text_en: 'Internal auditor training and authorization' },
          { text: 'Yönetim gözden geçirme toplantıları', text_en: 'Management review meetings' },
        ],
      },
      {
        icon: 'workspace_premium',
        phase: 'Sertifikasyon',
        phase_en: 'Certification',
        color: 'green',
        items: [
          { text: 'Akredite belgelendirme kuruluşu denetim ücreti', text_en: 'Accredited certification body audit fee' },
          { text: 'Yıllık gözetim denetimi maliyeti', text_en: 'Annual surveillance audit cost' },
          { text: '3 yıllık yeniden sertifikasyon denetimi', text_en: '3-year recertification audit' },
        ],
      },
    ],
  },

  faqSection: {
    title: 'ISO 27001 Hakkında Merak Edilenler',
    title_en: 'Frequently Asked Questions About ISO 27001',
    items: [
      {
        question: 'ISO 27001:2022 ile önceki sürümler arasındaki temel farklar nelerdir?',
        question_en: 'What are the key differences between ISO 27001:2022 and previous versions?',
        answer: '2022 revizyonuyla birlikte Ek-A\'daki kontrol sayısı 114\'ten 93\'e indirilmiş, 11 yeni kontrol eklenmiş ve kontroller 4 ana kategoriye yeniden düzenlenmiştir.',
        answer_en: 'With the 2022 revision, the number of controls in Annex A was reduced from 114 to 93, 11 new controls were added, and controls were reorganized into 4 main categories.',
      },
      {
        question: 'ISO 27001 sertifikası almak ne kadar sürer?',
        question_en: 'How long does it take to obtain ISO 27001 certification?',
        answer: 'Kuruluşun hazırlık düzeyine ve kapsamına bağlı olarak genellikle 3 ila 12 ay arasında sürer.',
        answer_en: 'It typically takes between 3 and 12 months depending on the organization\'s readiness level and scope.',
      },
      {
        question: 'ISO 27001 sertifikasının maliyeti ne kadar?',
        question_en: 'How much does ISO 27001 certification cost?',
        answer: 'Maliyet, organizasyon büyüklüğüne ve kapsama göre değişmekle birlikte danışmanlık, iç denetim ve sertifikasyon denetimi dahil toplam maliyetler geniş bir aralıkta olabilir.',
        answer_en: 'Costs vary by organization size and scope; total costs including consulting, internal audit, and certification audit can range widely.',
      },
      {
        question: 'ISO 27001, GDPR ile nasıl ilişkilidir?',
        question_en: 'How does ISO 27001 relate to GDPR?',
        answer: 'ISO 27001, GDPR\'ın teknik ve organizasyonel güvenlik gereksinimlerini karşılamaya yardımcı olan bir çerçeve sunar.',
        answer_en: 'ISO 27001 provides a framework that helps meet GDPR\'s technical and organizational security requirements.',
      },
      {
        question: 'ISO 27001 sertifikasının geçerlilik süresi ne kadardır?',
        question_en: 'How long is ISO 27001 certification valid?',
        answer: '3 yıl geçerlidir. Bu süre içinde yıllık gözetim denetimleri yapılır, 3. yılın sonunda yeniden sertifikasyon gerekir.',
        answer_en: 'Valid for 3 years. Annual surveillance audits are conducted during this period, and recertification is required at the end of year 3.',
      },
    ],
  },

  cta: {
    Title: 'ISO 27001 Yolculuğunuza Bugün Başlayın',
    Title_en: 'Start Your ISO 27001 Journey Today',
    Description: 'RUZY\'nin uzman ekibi ve akıllı platformuyla sertifikasyon sürecinizi hızlandırın.',
    Description_en: 'Accelerate your certification process with RUZY\'s expert team and intelligent platform.',
    primaryButtonText: 'Ücretsiz Demo İste',
    primaryButtonText_en: 'Request Free Demo',
    secondaryButtonText: 'Uzmanla Görüş',
    secondaryButtonText_en: 'Talk to an Expert',
  },
};

export default DEFAULT_ISO27001_DATA;